import { Auth } from '@aws-amplify/auth'
import { isAdditionalDetailsFilled, extractStateUrl } from '@/helpers/auth-utils'
import { redirect, isTargetSafe } from '@/services/redirect'
import { identify } from '@/services/tracking'

export const additionalDetailsGuard = async (to, from, next) => {
  try {
    // Get redirect URL from customState if present
    let stateUrl = extractStateUrl()

    // Check URL is https & a zavamed/partner domain
    stateUrl = isTargetSafe(stateUrl) ? stateUrl : undefined
    const nextParam = stateUrl ? { name: 'interstitial', query: { redirect: stateUrl } } : { name: 'interstitial' }
    const userData = await Auth.currentAuthenticatedUser({ bypassCache: true })

    // Identify patient ID & email for tracking
    const { patient_id: patientId, email, 'cognito:username': username } = userData.getSignInUserSession().getIdToken().payload
    identify(patientId, { email })

    // Send to interstitial page if additional details are not filled. For SAE, the check doesn't apply, hence skipping it for login.
    if (username.toUpperCase().startsWith('SAE_') || isAdditionalDetailsFilled(userData)) {
      redirect(stateUrl)
    } else {
      next(nextParam)
    }
  } catch (err) {
    next()
  }
}

const Login = () => import(/* webpackChunkName: "login-view" */ '@/views/Login.vue')
const Register = () => import(/* webpackChunkName: "register-view" */ '@/views/Register.vue')
const ForgotPassword = () => import(/* webpackChunkName: "forgot-password-view" */ '@/views/ForgotPassword.vue')
const RequestPassword = () => import(/* webpackChunkName: "request-password-view" */ '@/views/RequestPassword.vue')
const EmailVerification = () => import(/* webpackChunkName: "email-verification-view" */ '@/views/EmailVerification.vue')
const ChangePassword = () => import(/* webpackChunkName: "change-password-view" */ '@/views/ChangePassword.vue')
const Logout = () => import(/* webpackChunkName: "logout-view" */ '@/components/logout')
const Interstitial = () => import(/* webpackChunkName: "interstitial-view" */ '@/views/Interstitial.vue')

export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: additionalDetailsGuard
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/request-password',
    name: 'request-password',
    component: RequestPassword
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    component: EmailVerification
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: ChangePassword
  },
  {
    path: '/more-info',
    name: 'interstitial',
    component: Interstitial
  }
]
